import { useContext } from 'react';
import useLogin from "./../hooks/useLogin";
import useRole from '../hooks/useRole';

import CredentialsContext from "./../contexts/CredentialsContext";

/*
  RequireAuth - защищенный компонент
    Проверяет авторизацию пользователя.
    Если пользователь авторизован, то показывает защищенное содержимое, если нет, то показывает альтернативное содержимое
  Параметры:
    public / children - защищенное содержимое
    public - альтернативное содежимое
*/
export default function RequireAuth(props) {
  const _protected = props.protected ? props.protected : () => props.children;
  const _public = props.public || (() => '');
  const _roles = props.roles;

  const {credentials} = useContext(CredentialsContext);

  const {isLogged, isLoaded} = useLogin(credentials);

  const role = credentials?.role;
  console.log(role);

  if (isLoaded) {
    if (isLogged && (!_roles || _roles.includes(role))) {
      return _protected();
    } else {
      return _public();
    }
  } else return false
}
